import type { ToolbarContext } from "@ext/markdown/elements/article/edit/helpers/resolveToolbarContext";
import type { Instance, Placement, Props } from "tippy.js";

const getPlacement = (kind: ToolbarContext["kind"]): Placement => {
	switch (kind) {
		case "node":
		case "container":
			return "top-end";
		case "file":
			return "bottom-start";
		default:
			return "top-start";
	}
};

export const updatePlacement = (instance: Instance<Props> | null, context: ToolbarContext) => {
	const placement = getPlacement(context.kind);
	if (instance && instance.props.placement !== placement) instance.setProps({ placement });
};
